import { PROFILE_KEY, PROFILE_ROLE } from '../../constants'
import { getValueReduxUtil } from '../../../../modules/redux/utils/get-value'

function isAdminProfileUtil (profile) {
  const role = getValueReduxUtil(profile, PROFILE_KEY.ROLE)
  return role === PROFILE_ROLE.ADMIN
}

export default isAdminProfileUtil
